import { octaChat, demia } from '@/utils/chat-widgets'
import { buildDemiaVariants, resolveDemiaVariant } from '@/utils/demia-variants'
import { clientService } from '@/services/client-service'

const DEMIA = 'demia'
const OCTADESK = 'octadesk'
const OCTA_PERSON_DOMAIN_TYPE = 2
const OCTA_COMPANY_FIELD_ID = 'empresa'
const DEMIA_VARIANTS = buildDemiaVariants({
  logisticaAmbevEcosystemId: process.env.VUE_APP_LOGISTICA_AMBEV_ECOSYSTEM_ID,
  revendasAmbevEcosystemId: process.env.VUE_APP_REVENDAS_AMBEV_ECOSYSTEM_ID
})

function isAutoLoginEnabled() {
  return process.env.VUE_APP_OCTADESK_AUTO_LOGIN === 'true'
}

async function buildCompanyFields(clientCode) {
  if (!clientCode) return []

  try {
    const { data } = await clientService.getByCode(clientCode)
    if (!data?.name) return []

    return [
      {
        id: OCTA_COMPANY_FIELD_ID,
        value: data.name,
        domainType: OCTA_PERSON_DOMAIN_TYPE
      }
    ]
  } catch (error) {
    return []
  }
}

const state = {
  activeChat: null,
  octaLoginKey: null
}

const mutations = {
  SET_ACTIVE_CHAT(state, chat) {
    state.activeChat = chat
  },
  SET_OCTA_LOGIN_KEY(state, key) {
    state.octaLoginKey = key
  }
}

const getters = {
  demiaVariant(state, getters, rootState) {
    return resolveDemiaVariant(
      rootState.user.userEcosystems || [],
      DEMIA_VARIANTS
    )
  },
  identityReference(state, getters, rootState) {
    return `${rootState.user.userClient}:${
      getters.demiaVariant?.ecosystemId ?? OCTADESK
    }`
  }
}

const actions = {
  async applyStrategy({ commit, state, rootGetters, getters, dispatch }) {
    if (!rootGetters.userClient) return
    const variant = getters.demiaVariant
    const target = variant ? DEMIA : OCTADESK
    if (target === DEMIA) {
      demia.setUser({
        nome: rootGetters.name,
        email: rootGetters.userEmail,
        empresa: variant.company
      })
      demia.load(variant.embedUrl)
      octaChat.hide()
    } else {
      demia.cleanup()
      await dispatch('autoLoginOctaChat')
      octaChat.show()
    }
    commit('SET_ACTIVE_CHAT', target)
  },
  async autoLoginOctaChat({ commit, state, rootGetters }) {
    if (!isAutoLoginEnabled()) return

    const name = rootGetters.name
    const email = rootGetters.userEmail
    const clientCode = rootGetters.userClient
    if (!name || !email) return

    const loginKey = `${email}|${clientCode}`
    if (state.octaLoginKey === loginKey) return

    const customFields = await buildCompanyFields(clientCode)
    octaChat.login({ name, email, customFields })
    commit('SET_OCTA_LOGIN_KEY', loginKey)
  },
  hide({ state }) {
    if (state.activeChat === DEMIA) demia.cleanup()
    else octaChat.hide()
  },
  show({ state }) {
    if (state.activeChat === DEMIA) demia.restart()
    else octaChat.show()
  },
  toggle({ state }) {
    if (state.activeChat === DEMIA) demia.restart()
    else octaChat.toggle()
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
